var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-item-detail-container",
      class: _vm.setResponsiveClasses
    },
    [
      _vm.$mq === "desktop" ? _c("back-navigation") : _vm._e(),
      _vm._v(" "),
      !_vm.hasItem ? _c("BaseLoader") : _vm._e(),
      _vm._v(" "),
      _c("adapted-component", {
        attrs: { "adapter-name": "MenuItemDetail", path: "menu" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12ec4446", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12ec4446","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/MenuItemDetailRoute.vue
// module id = null
// module chunks = 